/**
 * Created by mkoehler on 13.09.17.
 */
import Masonry from 'masonry-layout';
import {DomHelper} from "../general/utils";

export default class MasonryLayout {
    constructor() {
        this.msnry = null;
        this.isInitialized = false;
        MasonryLayout.initOrDestroyMasonryByWindowSize();
        MasonryLayout.handleWindowResize();

    }

    static initMasonry () {
        if(document.getElementsByClassName('masonry-item-wrapper').length) {

            let _scope = this;
            const grid = document.querySelector('.masonry-item-wrapper');

            if (!this.isInitialized) {
                this.msnry = new Masonry(grid, {
                    itemSelector: '.masonry-item',
                    percentPosition: true,
                    horizontalOrder: true,
                    transitionDuration: 0
                });

                this.isInitialized = true;
                this.msnry.layout();

                // refresh layout on image load
                for(let item of Array.from(grid.getElementsByClassName('masonry-item'))) {
                    let img = item.getElementsByTagName('img')[0];

                    if(DomHelper.elementExists(img)) {

                        img.onload = function () {
                            _scope.msnry.layout();
                        }
                    }
                }
            } else {
                MasonryLayout.destroyMasonry();
                MasonryLayout.initOrDestroyMasonryByWindowSize();
            }
        }
    }

    static destroyMasonry () {
        if(this.isInitialized && this.msnry !== null) {
            this.msnry.destroy();
            this.isInitialized = false;
        }
    }



    static handleWindowResize () {
        let event = DomHelper.isTouchDevice() ? 'orientationchange' : 'resize';

        window.addEventListener(event, function () {
            setTimeout(function () {
                MasonryLayout.initOrDestroyMasonryByWindowSize();
            }, 100);
        });
    }

    static initOrDestroyMasonryByWindowSize () {
        if(document.getElementsByClassName('masonry-item').length) {
            if (DomHelper.getWindowInnerWidth() >= 768) {
                MasonryLayout.initMasonry();
            } else {
                MasonryLayout.destroyMasonry();
            }
        }
    }
}